import React from 'react';
import styled from 'styled-components';

// Components
import SubjectAccordion from '../../../../../../pages/subject/components/SubjectAccordion';
import CorrectionSummary from './CorrectionSummary';
import CorrectionDetails from './CorrectionDetails';

// Custom hooks
import useStatus from '../../../../../../hooks/common/useStatus';
import Text from '../../../../../../components/common/Text';
import { useQueryParams } from '../../../../../../hooks/useQueryParams';

import { useParams } from 'react-router-dom';
import * as encode from 'nodejs-base64-encode';
import { useSelector } from 'react-redux';
import ADIButton from '../../../../../../components/shared/chat-layout/ADIButton';
import CorrectionFeedbackAIModal from '../../IA/CorrectionFeedbackAIModal';

const Correction = (props) => {
    const {
        presentation,
        deliveries,
        showHistorial,
        resourceId,
        isAICorrection,
        presentationId,
    } = props;

    const { repo_id } = useSelector((state) => state.auth.user);
    const user = useSelector((state) => state.auth.user);
    const params = useQueryParams();

    const { id } = useParams();
    const asignaturaIdBase64 = params.get('id');

    const oaId = encode.decode(id, 'base64');
    const asignaturaId = encode.decode(asignaturaIdBase64, 'base64');

    const { setLightStateColor } = useStatus();

    return (
        <CorrectionWrapper>
            {deliveries.map((deliver) => {
                return (
                    <SubjectAccordion
                        summary={CorrectionSummary}
                        details={CorrectionDetails}
                        defaultExpanded={true}
                        key={deliver.id}
                        data={deliver}
                        description={
                            deliver.professor_comment || deliver.student_comment
                                ? {
                                      professor_comment:
                                          deliver.professor_comment,
                                      student_comment: deliver.student_comment,
                                      professor_name: deliver.professor_name,
                                  }
                                : false
                        }
                        values={deliver}
                        borderRadius="20px"
                        height="fit-content"
                        decoratorColor={setLightStateColor(
                            deliver.redo ? 'rehacer' : deliver.state
                        )}
                        decorator={false}
                        decoratorHeight="0px"
                        decoratorWidth="0px"
                        detailsPadding="0 0 0 1.1rem"
                        boxShadow="box-shadow: 0px 3px 6px 0px #0000003B, 0px 3px 6px 0px #00000029;"
                        border="1px solid #C4C4C4"
                        showInfo={!showHistorial}
                        presentation={presentation}
                    />
                );
            })}
            {isAICorrection &&
                deliveries.some((deliver) => deliver.state !== 'pendiente') && (
                    <AIFeedbackContainer>
                        <AILeftSide>
                            <ADIButton />
                            <Text weight="600" fontSize="16px">
                                La corrección de mi entrega con IA me resultó:
                            </Text>
                        </AILeftSide>
                        <AIRightSide>
                            <CorrectionFeedbackAIModal
                                workflowUrl="https://n8n.internal.aden.org/webhook/demo-workflow"
                                additionalData={{
                                    id_asignatura: asignaturaId,
                                    id_recurso: resourceId,
                                    id_usuario: user?.repo_id,
                                    id_objeto_aprendizaje: oaId,
                                    id_evaluacion: presentationId,
                                }}
                                predefinedMessages={[
                                    'La IA me corrigió la actividad de manera incorrecta',
                                    'Me gustó como me corrigió la IA',
                                ]}
                                sendInitialRequestOnOpen={true}
                                initialMessage="me gustó la corrección"
                                triggerFaIcon="fa-light fa-thumbs-up"
                                buttonText="Útil y acertada"
                                customTriggerStyles={{
                                    backgroundColor: '#B31D15',
                                    color: '#fff',
                                    padding: '0.5rem 1rem',
                                    borderRadius: '180px',
                                    fontSize: '14px',
                                    gap: '0.5rem',
                                    width: 'fit-content',
                                }}
                                sharedKey="ai-correction-feedback"
                                behaviourAction="correcciones_ia_me_gusta"
                                behaviourDetail={JSON.stringify({
                                    partner: repo_id,
                                    objeto_aprendizaje: oaId,
                                    entrega: presentation?.submissions?.[0]?.id,
                                })}
                            />
                            <CorrectionFeedbackAIModal
                                workflowUrl="https://n8n.internal.aden.org/webhook/demo-workflow"
                                additionalData={{
                                    id_asignatura: asignaturaId,
                                    id_recurso: resourceId,
                                    id_usuario: user?.repo_id,
                                    id_objeto_aprendizaje: oaId,
                                    id_evaluacion: presentation?.id,
                                }}
                                predefinedMessages={[
                                    'La IA me corrigió la actividad de manera incorrecta',
                                    'Me gustó como me corrigió la IA',
                                ]}
                                sendInitialRequestOnOpen={true}
                                initialMessage="no me gustó la corrección"
                                triggerFaIcon="fa-solid fa-thumbs-down"
                                buttonText="Incorrecta"
                                customTriggerStyles={{
                                    backgroundColor: 'transparent',
                                    color: '#B31D15',
                                    padding: '0.5rem 1rem',
                                    borderRadius: '180px',
                                    border: '1px solid #B31D15',
                                    fontSize: '14px',
                                    gap: '0.5rem',
                                    width: 'fit-content',
                                    hoverBackgroundColor: '#B31D15',
                                    hoverColor: '#fff',
                                }}
                                sharedKey="ai-correction-feedback"
                                behaviourAction="correcciones_ia_no_me_gusta"
                                behaviourDetail={JSON.stringify({
                                    partner: repo_id,
                                    objeto_aprendizaje: oaId,
                                    entrega: presentation?.submissions?.[0]?.id,
                                })}
                            />
                        </AIRightSide>
                    </AIFeedbackContainer>
                )}
        </CorrectionWrapper>
    );
};

export default Correction;

const CorrectionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
`;

const AIFeedbackContainer = styled.div`
    width: 100%;
    height: fit-content;
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media screen and (max-width: 768px) {
        flex-direction: column;
        gap: 1rem;
    }
`;

const AILeftSide = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
    padding: 0 0.5rem;
`;

const AIRightSide = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
    padding: 0 0.5rem;
`;
